import {useQuery} from "@tanstack/react-query";
import {fetchTargetGroupsLvl2} from "api/targetGroups/fetchTargetGroupsLvl2";

export function useFetchTargetGroupsLvl2(parentGroupId, schoolId, enabled = true) {
    const { data, error, isLoading, refetch } = useQuery({
        queryKey: ["targetGroups/level2", parentGroupId, schoolId || "all"],
        queryFn: () => fetchTargetGroupsLvl2(parentGroupId, schoolId),
        enabled: !!parentGroupId && enabled,
    });

    return {
        targetGroupsLvl2: data || [],
        targetGroupsLvl2Error: error,
        targetGroupsLvl2IsLoading: isLoading,
        refetchTargetGroupsLvl2: refetch,
    };
}
